export const GatewayBeneficiariesTableHeader = () => {
  return (
    <div className="cds--structured-list-thead">
      <div className="cds--structured-list-row cds--structured-list-row--header-row">
        {/* <div className="cds--structured-list-th font-ctm--semibold">
            ##
          </div> */}

        <div className="cds--structured-list-th">Id</div>

        <div className="cds--structured-list-th font-ctm--semibold ">
          Gateway
        </div>

        <div className="cds--structured-list-th">Alias</div>

        <div className="cds--structured-list-th font-ctm--semibold">
          Merch. Name
        </div>

        <div className="cds--structured-list-th font-ctm--semibold">
          Merch. Code
        </div>

        <div className="cds--structured-list-th">
          <span className="font-ctm--bold">Action</span>
        </div>
      </div>
    </div>
  );
};
